import { h } from 'preact';

const ProductBadgeLaura = ({ badges, className, containerClassName }) => {
  if (!badges || badges.length === 0) return null;

  const getBadgeTypeClass = (badge) => {
    // Match typical inseam patterns: 25", 28", 30", 32", 28 po, etc.
    const isInseam = /[0-9]{2}\s?(("| po)|po)/i.test(badge);
    return isInseam ? 'product-inseam-badge' : 'product-size-badge';
  };

  return (
    <div className={containerClassName || 'relative'}>
      {badges.map((badge, index) => (
        <div
          key={index}
          className={`${getBadgeTypeClass(badge)} ${className || ''}`.trim()}
          dangerouslySetInnerHTML={{ __html: badge }}
        />
      ))}
    </div>
  );
};

export default ProductBadgeLaura;
